import { motion } from 'motion/react'
import { spring } from '@/lib/motion'

/** Highlight behind the active sidebar entry; slides between entries (shared layout). */
export function ActivePill() {
  return (
    <motion.span
      layoutId="sidebar-active"
      transition={spring.snappy}
      className="absolute inset-0 rounded-[10px] bg-surface shadow-card dark:bg-white/[0.08] dark:shadow-none"
      aria-hidden
    />
  )
}
